// frontend/src/pages/AutoLogin.jsx
// Connexion automatique par QR Code URL (Magic Link)
// URL: https://lafermedupetitessart.fr/auto/CLI-XXXXXX/QR-XXXXXX
// 73+ Papy - Décembre 2025

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const AutoLogin = () => {
  const { code_client, token } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    // Si déjà connecté avec le même code client → direct au catalogue
    if (user && user.code_client === code_client) {
      console.log('✅ Déjà connecté, redirection catalogue');
      navigate('/catalog', { replace: true });
      return;
    }

    // Authentification automatique
    const autoAuth = async () => {
      try {
        setStatus('authenticating');
        
        // Appel API d'authentification directe
        const response = await fetch(`${API_BASE}/auth/direct/${code_client}/${token}`);
        const data = await response.json();

        if (data.success) {
          // ✅ Sauvegarder le token et l'utilisateur
          if (data.token) {
            localStorage.setItem('farm_token', data.token);
          }
          localStorage.setItem('farm_user', JSON.stringify(data.user));
          
          console.log('✅ Auto-login réussi:', data.user.nom_prenom);
          setStatus('success');
          
          // Petit délai pour que le state se propage, puis redirection
          setTimeout(() => {
            window.location.href = '/catalog';  // Force reload pour rafraîchir AuthContext
          }, 500);
          
        } else {
          console.log('❌ Auto-login échoué:', data.error);
          setStatus('error');
          setError(data.error || 'Lien invalide ou expiré');
        }
        
      } catch (err) {
        console.error('❌ Erreur auto-login:', err);
        setStatus('error');
        setError('Erreur de connexion au serveur');
      }
    };

    if (code_client && token) {
      autoAuth();
    } else {
      setStatus('error');
      setError('Lien incomplet');
    }
  }, [code_client, token, navigate, user]);

  // ==========================================
  // AFFICHAGE SELON LE STATUS
  // ==========================================

  if (status === 'loading' || status === 'authenticating') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-green-500 border-t-transparent mx-auto mb-6"></div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            🌿 Connexion en cours...
          </h1>
          <p className="text-gray-600">
            Veuillez patienter
          </p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="text-6xl mb-6">✅</div>
          <h1 className="text-2xl font-bold text-green-700 mb-2">
            Connexion réussie !
          </h1>
          <p className="text-gray-600">
            Redirection vers votre espace...
          </p>
        </div>
      </div>
    );
  }

  // Status === 'error'
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <div className="text-6xl mb-6">😕</div>
        <h1 className="text-2xl font-bold text-red-700 mb-4">
          Lien invalide
        </h1>
        <p className="text-gray-600 mb-6">
          {error}
        </p>
        <div className="space-y-3">
          <button
            onClick={() => navigate('/auth')}
            className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition-colors font-medium"
          >
            🔑 Se connecter manuellement
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300 transition-colors font-medium"
          >
            🏠 Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutoLogin;